import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { Solution } from './Solution';
import { Bonuses } from './Bonuses';
import { Benefits } from './Benefits';
import { Offer } from './Offer';
import { Guarantee } from './Guarantee';
import { Testimonials } from './Testimonials';
import { FAQ } from './FAQ';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-ocean-teal-light selection:text-ocean-teal-dark" data-id="element-113">
      <main data-id="element-114">
        <Hero data-id="element-115" />
        <PainPoints data-id="element-116" />
        <Solution data-id="element-117" />
        <Bonuses data-id="element-118" />
        <Benefits data-id="element-119" />
        <Offer data-id="element-120" />
        <Guarantee data-id="element-121" />
        <Testimonials data-id="element-122" />
        <FAQ data-id="element-123" />
        <FinalCTA data-id="element-124" />
      </main>
      <Footer data-id="element-125" />
      <StickyCTA data-id="element-126" />
    </div>;
}